import { SIMULATED_DATA, DAILY_ALLOCATION } from './constants';

// Calculate user allocation based on their contribution relative to total contributions
export const calculateUserAllocation = (contribution, totalContributions, dailySupply) => {
    if (!totalContributions || totalContributions === 0) return 0;
    return (contribution / totalContributions) * dailySupply;
};

// Simulate daily allocation based on historical data
export const simulateDailyAllocation = (day, userContribution = 0) => {
    // Get simulated data for the day, or use default values if not available
    const defaultData = { users: 0, sol: 0, jinu: DAILY_ALLOCATION };
    const simData = SIMULATED_DATA[day] || defaultData;

    return {
        users: simData.users,
        amount: simData.sol,
        allocation: simData.jinu
    };
};

// Calculate total allocation for a user across all days
export const calculateTotalAllocation = (contributions, dailySupplies) => {
    return Object.entries(contributions).reduce((total, [day, amount]) => {
        const dailySupply = dailySupplies[day] || DAILY_ALLOCATION;
        const allocation = calculateUserAllocation(amount, amount, dailySupply); // In simulation, user is the only contributor
        return total + allocation;
    }, 0);
};
